import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIdea = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.188 9.807a6.77 6.77 0 0 0 4.137 6.248v2.265a2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68v-2.254c2.836-1.198 4.68-4.323 3.977-7.711-.542-2.594-2.64-4.68-5.233-5.21-4.38-.888-8.241 2.432-8.241 6.662M12.254 16.07h2.438"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgIdea);
export default ForwardRef;
